import { useCallback, useState } from 'react';

type WebStorageHook = <T>(key: string, initialValue: T) => [T, (s: T) => void];

export function createWebStorageHook(storage?: Storage): WebStorageHook {
  if (!storage) {
    return (_key, initialValue) => {
      return [initialValue, () => ({})];
    };
  }

  return <T>(key: string, initialValue: T) => {
    const [storedValue, setStoredValue] = useState<T>(() => {
      try {
        const item = storage.getItem(key);
        if (item) {
          return JSON.parse(item);
        } else if (initialValue !== undefined) {
          storage.setItem(key, JSON.stringify(initialValue));
        }

        return initialValue;
      } catch (error) {
        console.log(error);
        return initialValue;
      }
    });

    const setValue = useCallback(
      (value: T): void => {
        try {
          setStoredValue(value);
          if (value === undefined) {
            storage.removeItem(key);
          } else {
            storage.setItem(key, JSON.stringify(value));
          }
        } catch (error) {
          console.log(error);
        }
      },
      [key, setStoredValue]
    );

    return [storedValue, setValue];
  };
}
